/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMusicShare = createReactComponent("outline", "music-share", "IconMusicShare", [["path", { "d": "M3 17a3 3 0 1 0 6 0a3 3 0 0 0 -6 0", "key": "svg-0" }], ["path", { "d": "M9 17v-13h10v9", "key": "svg-1" }], ["path", { "d": "M9 8h10", "key": "svg-2" }], ["path", { "d": "M16 22l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21.5v-4.5h-4.5", "key": "svg-4" }]]);

export { IconMusicShare as default };
//# sourceMappingURL=IconMusicShare.mjs.map
